import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingServicedeskRovoServiceRoute: InvariantJiraRoute = {
	name: 'project-setting-servicedesk-rovo-service',
	path: '/jira/servicedesk/projects/:projectKey/settings/rovo/rovo-service',
	exact: true,
};
